import React from 'react';
import { Common } from '@thecvlb/design-system/lib/src';
import classNames from 'classnames';

import PlansInfo from './Component/PlansInfo';
import { NextStepCardProps } from './nextStepCard.types';

import SeparatorIcon from 'assets/icons/vertical-separator.svg?react';

const NextStepCard: React.FC<NextStepCardProps> = ({
  title,
  description,
  isActive = false,
  isCompleted = false,
  showSeparator = false,
  isUpdated,
  showPlanInfo
}) => {
  const cardClassName = classNames('flex flex-col gap-2 rounded-2xl bg-white p-4', {
    '!bg-gray-50': isCompleted,
    'border-2 border-primary-300 shadow-xl': isActive
  });
  const headingClassName = classNames('text-mBase font-bold', {
    'text-gray-500': isCompleted
  });
  const descriptionClassName = classNames('text-mSm text-gray-500', {
    'text-gray-700': isActive
  });

  const planInfoSection = showPlanInfo && <PlansInfo />;

  const separatorSection = showSeparator && (
    <div className="pl-6">
      <SeparatorIcon className="mb-0.5" />
    </div>
  );

  return (
    <>
      <div className={cardClassName}>
        {isUpdated && <Common.ColorTag color="orange" text="Updated" />}
        {isCompleted && <Common.ColorTag color="gray" icon="check" text="Complete" size="sm" />}
        <h4 className={headingClassName}>{title}</h4>
        <p className={descriptionClassName}>{description}</p>
        {planInfoSection}
      </div>
      {separatorSection}
    </>
  );
};

export default NextStepCard;
